// internal
import { axios, def, storage, handleError, handleResponse, setLiked } from './internal';
import { debounceSettle } from '../request-control/debounce';

// `post` is the post as shown ({ _id, liked, likes }); `onClickLike(liked, likes)` updates the screen. The screen changes
// at once and the like is sent through the debounce (see request-control/debounce.js). The server applies it asynchronously and
// returns no count, so the new count is derived here from the state the user saw.
function Like(post, onClickLike, setData) {
    const id = post._id;

    // A browsing guest cannot like: send at once so the guest gate (app.jsx) asks for login, with no optimistic flip.
    if (!storage.transience.getValue().user) {
        axios.put(`/api/posts/${encodeURIComponent(id)}/like`, { liked: !post.liked }).catch(handleError);
        return;
    }

    const liked = !post.liked;
    const likes = Math.max(0, (post.likes ?? 0) + (liked ? 1 : -1));
    setLiked(id, liked, post.expireAt);
    onClickLike(liked, likes);

    debounceSettle(`like:${id}`, {
        base: !!post.liked,
        want: liked,
        send: (want, options) => {
            setData?.((prev) => ({ ...prev, loading: true }));
            return axios
                .put(`/api/posts/${encodeURIComponent(id)}/like`, { liked: want }, options)
                .then((res) => {
                    if (res.data.code === def.ErrorCode.OK) return true;
                    handleResponse(res);
                    return false;
                })
                .catch((err) => {
                    handleError(err);
                    return false;
                })
                .finally(() => setData?.((prev) => ({ ...prev, loading: false })));
        },
        revert: () => {
            setLiked(id, !!post.liked, post.expireAt);
            onClickLike(!!post.liked, post.likes ?? 0);
        },
    });
}

export { Like };
